<template>
  <table-layout title="مدیریت کاربران">
    <template #buttons>
      <router-link :to="{ name: 'TrashUser' }">
        <b-button pill variant="danger"> سطل زباله</b-button>
      </router-link>
      <router-link class="ml-3" :to="{ name: 'CreateUser' }">
        <b-button pill variant="purple">کاربرجدید</b-button>
      </router-link>

      <b-btn pill variant="info" class="ml-2" v-b-toggle.filters>
        فیلترها
      </b-btn>

      <export-users/>

      <data-import-manager/>

    </template>

    <template #table>
      <user-items :items="persons"></user-items>

      <div class="row pt-3">
        <div class="mt-3 color">
          <pagination :meta="meta" :on-change-page="changePage"/>
        </div>
      </div>

    </template>


  </table-layout>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import TableLayout from '../../components/dashboard/TableLayout'
import Pagination from "../../components/dashboard/Pagination"
import UserItems from "../../components/dashboard/User/Items"
import ExportUsers from "@/plugin/components/dashboard/User/ExportUsers.vue";
import DataImportManager from "../../components/dashboard/DataImport/DataImportManager.vue";


export default {
  name: "User",
  components: {DataImportManager, ExportUsers, TableLayout, Pagination, UserItems},

  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      persons: "User/getPersons",
      meta: "User/getPaginationMeta",
      links: "User/getPaginationLinks",
    }),
  },
  methods: {
    ...mapActions({
      getPersons: "User/getPersons",
    }),
    changePage(page) {
      this.getPersons(page)
    },
  },
  mounted() {
    this.$store.commit('User/setFilters', {key: 'search', value: ''})
    this.getPersons()
  },
}
</script>

<style scoped>

</style>